export enum GiftcardAmount {
  fifty = 1,
  hundred,
  twohundred,
  twohundredfifty,
  threehundred,
  custom,
}

export function getTopupAmount(amount: GiftcardAmount, custom: number | null) {
  switch (amount) {
    case GiftcardAmount.fifty:
      return 50
    case GiftcardAmount.hundred:
      return 100
    case GiftcardAmount.twohundred:
      return 200
    case GiftcardAmount.twohundredfifty:
      return 250
    case GiftcardAmount.threehundred:
      return 300
    case GiftcardAmount.custom:
    default:
      return custom ? +custom : 0
  }
}

export interface TopupGiftcard {
  id: number
  code: string
  topupAmount: GiftcardAmount
  customAmount: number | null
  valid: boolean
}

export const initialTopupGiftcard: TopupGiftcard = {
  id: 1,
  code: '',
  topupAmount: GiftcardAmount.hundred,
  customAmount: null,
  valid: false,
}

export interface TopupOrder {
  name: string
  email: string
  activeGiftcard: number
  giftcards: TopupGiftcard[]
}

export const initialTopupOrder: TopupOrder = {
  name: '',
  email: '',
  activeGiftcard: 1,
  giftcards: [{ ...initialTopupGiftcard }],
}
